// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2466":"9d819e5e","2954":"9d819e5e","3265":"9d819e5e","4440":"9d819e5e","7900":"9d819e5e","9013":"9d819e5e"}[chunkId] + ".chunk.css";
};